<template>
	<i class="swatch i-simple inline-block">
		<svg class="block" viewBox="0 0 16 16" @click="$emit('click')">
			<circle class="swatch__dark-ring" cx="8" cy="8" r="5.5" fill="rgba(255,255,255,.5)" />
			<circle class="swatch__proper" cx="8" cy="8" r="6" :fill="color" stroke="black" />
			<path class="swatch__white-active-indication hide" d="M14.9143 5.3876L6.56446 13.7374L2.71069 9.88367" fill="transparent" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
			<circle class="swatch__active-indication hide" cx="8" cy="8" r="5" />
		</svg>
	</i>
</template>

<script>
	export default {
		name: 'CSwatch',
		props: {
			color: {
				type: String,
				required: true,
				default: 'transparent'
			}
		}
	};
</script>

<style lang="scss">
.swatch {
	stroke-width: 1;

	circle:not(.swatch__active-indication, .swatch__dark-ring) {
		r: 4.7; // The <circle> should render as 9.99px if the svg is 17px ($size__icon)
	}

	& > svg {
		width: 100%;
		height: 100%;

		[stroke] {
			stroke: rgba(black, 15%);
		}
	}

	.swatch__white-active-indication {
		transform: scale(.5);
		transform-origin: 50% 50%;
	}

	&.is-active {

		.swatch__active-indication {
			display: block;
			fill: transparent;
			stroke: white;
			stroke-width: .8;
			r: 3.4;
		}

		[fill='#ffffff'] + .swatch__white-active-indication {
			display: block;
			transform: scale(.35);
			font-size: 8px;
			stroke: var(--icon-subtle);
			stroke-width: 1.5;
		}
	}
}
</style>
